<template>
    <div class="mb-3">
        <div class="input-group">
            <a class="btn btn-outline-secondary" @click="clear">
                <span class="glyphicon glyphicon-repeat"></span>
                クリア...
            </a>
            <input type="text" class="form-control input-long" id="simple-search-input" ref="input" autocomplete="off" v-autofocus
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                :placeholder="placeholder"
                @keyup.enter="$emit('find')">
            <button type="button" class="btn btn-outline-primary" @click="$emit('find')">
                <span class="glyphicon glyphicon-search"></span>
                検索
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ["modelValue", "placeholder"],
    methods: {
        clear() {
            this.$emit('clear');
            this.$refs.input.focus();
        }
    },
    directives: {
        autofocus: {
            mounted(el) {
                el.focus();
            }
        }
    },
}
</script>
